'use client';

import React from 'react';

import LinkButton, {
  LinkButtonProps,
} from '@/components/atoms/LinkButton';
import { LinkButtonStrapiProps } from '@/components/atoms/LinkButton/LinkStrapi';
import { transformFromCMSLink } from '@/components/atoms/LinkButton/utils';

import { handleHeroButtonLinkClick } from '../helpers';
import { useTrackHomepageCTA } from '../useTrackHomepageCTA';

type Props = {
  button: LinkButtonProps;
  eventName?: string;
};

function getClickTarget(target?: string) {
  if (target === '_blank') return '_blank';
  return '_self';
}

const HomepageLinkButton = ({ button, eventName }: Props) => {
  const trackCtaClick = useTrackHomepageCTA(button.children, eventName);

  return (
    <LinkButton
      {...button}
      onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        trackCtaClick();
        return handleHeroButtonLinkClick(
          e,
          button.href,
          getClickTarget(button.target)
        );
      }}
    />
  );
};

export function HomepageLinkButtonStrapi({
  block,
  inner,
  eventName,
}: {
  block: LinkButtonStrapiProps;
  inner?: Partial<LinkButtonProps>;
  eventName?: string;
}) {
  const props = {
    ...transformFromCMSLink(block),
    ...inner,
    children: block.text,
  } as LinkButtonProps;

  return <HomepageLinkButton button={props} eventName={eventName} />;
}

export default HomepageLinkButton;
